/**
 * Individual validation functions for overview items
 */
export const isValidFeature = (data) => !!data?.title;
export const isValidTeamMember = (data) => !!data?.name;
export const isValidPricingPackage = (data) => !!data?.name;
export const isValidTestimonial = (data) => !!data?.quote;
export const isValidCaseStudy = (data) => !!data?.title;

/**
 * Map to easily access validation functions by section key
 */
export const VALIDATION_MAP = {
  features: isValidFeature,
  team: isValidTeamMember,
  pricing: isValidPricingPackage,
  testimonials: isValidTestimonial,
};
